"use strict";

import banner from "../data/banner.js";
import cookie from "../util/cookie";
import links from "../components/links";

export default {
  init: () => {
    /**
     * Elementos
     */
    let data = banner.getData();
    let gigas = {
        numero: document.querySelector(".highlight-plan--details--title"),
        plano: document.querySelector(".highlight-plan--details--description--dados"),
        app: document.querySelector(".highlight-plan--details--description--apps"),
      },
      preco = {
        real: document.querySelector(".highlight-plan--buy--price--real"),
        centavos: document.querySelector(".highlight-plan--buy--price--column--centavos"),
        frequencia: document.querySelector(".banner--preco--content--column--frequencia"),
      },
      button = document.querySelector(".highlight-plan--buy--cta--btn");

    gigas.numero.innerHTML = data.double ? `${data.doubleredes.giga_full}` : `${data.giga_full}`;

    if (data.double) {
      data.doubleredes.dados_plano.map((plano) => {
        gigas.plano.innerHTML += `${plano.titulo} `;
      });
    } else {
      data.dados_plano.map((plano) => {
        gigas.plano.innerHTML += `${plano.titulo} `;
      });
    }

    gigas.app.innerHTML = `${data.app.titulo} `;

    preco.real.innerHTML = data.double ? `${data.doubleredes.preco.real}` : `${data.preco.real}`;
    preco.centavos.innerHTML = data.double
      ? `${data.doubleredes.preco.centavos}`
      : `,${data.preco.centavos}`;

    button.addEventListener("click", () => {
      let ga = cookie.readCookie("_ga") ? `&_ga=${cookie.readCookie("_ga")}` : "";
      let packages = data.double ? "&packages=" + data.packageDR : "&packages=" + data.package;
      window.location.href =
        data.link +
        "&id_origem_vivo=b2c-movel_ananke_banner_controle_vantagens&origin=b2c-movel_ananke_banner_controle_vantagens" +
        ga +
        "&" +
        links.getParams();
    });
  },
};
